<div
    class="px-1.5 pb-1.5 pt-0.5 font-siemens-sans text-xs leading-4 text-[var(--sh-editor-muted)]"
    data-testid="global-editor-menu-container-word"
>
    {{ menu().word }}
</div>

@if (menu().loading) {
    <div
        class="px-2.5 py-2 font-siemens-sans text-sm leading-5 text-[var(--sh-editor-muted)]"
        data-testid="global-editor-menu-container-loading"
    >
        Loading suggestions...
    </div>
} @else {
    @for (suggestion of menu().suggestions; track suggestion) {
        <button
            type="button"
            class="flex w-full items-center rounded-lg border-0 bg-transparent px-2.5 py-2 text-left font-siemens-sans text-sm leading-5 text-[var(--sh-editor-text)] transition-colors duration-200 hover:bg-[var(--sh-editor-hover)] hover:text-[var(--sh-editor-link)]"
            [attr.data-testid]="suggestionTestId(suggestion)"
            (click)="selectSuggestion($event, suggestion)"
        >
            {{ suggestion }}
        </button>
    }
}
